import Vue from 'vue/dist/vue.esm.js'
import { map, filter } from 'underscore'
import Select2Mixin from '../../mixins/select2_mixin.js.coffee'

KCVS.Views.ReportFileGroupSelect = Vue.extend(
  template: JST['report_file_groups/file_group_select']()
  props: ['groups', 'initialSelectedGroupId', 'fileId']
  data: ->
    selected: @initialSelectedGroupId
  computed:
    options: ->
      @groups
    collection: ->
      @options.map( (opt) -> [opt.name, opt.id])
    selectedGroup: ->
      @options.filter( (option) =>
        option.id.toString() == @selected
      )[0]
  watch:
    selected: ->
      if @selectedGroup.id != @initialSelectedGroupId
        EventBus.$emit('group-changed', @selectedGroup.id, @initialSelectedGroupId, @fileId)
  components:
    groupSelect: Select2Mixin
)
